import _ from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import misc from '../../misc';

export class ClientList extends Component {
  renderClients() {
    const { isLoading, isError, clients, searchTerm } = this.props;

    if (clients.length === 0 && !isLoading && !isError) {
      if (searchTerm !== '') {
        return (
          <div className="alert alert-secondary" role="alert">
            No clients found.
          </div>
        );
      } else {
        return (
          <div className="alert alert-info" role="alert">
            Click <strong>+ New</strong> above to add your first client.
          </div>
        );
      }
    }

    return _.map(clients, client => {
      return (
        <Link
          to={'/clients/' + client.id}
          key={client.id}
          className="list-group-item list-group-item-action"
        >
          {client.firstName} {client.lastName}
        </Link>
      );
    });
  }

  render() {
    const {
      isLoading,
      isError,
      errorMessage,
      searchTerm,
      onSearchChange
    } = this.props;
    return (
      <div className="col-md-9 content">
        <div className="row justify-content-md-center">
          <misc.components.SearchBar
            term={searchTerm}
            onChange={onSearchChange}
            showNewButton={true}
            newButtonRoute="/clients/new"
          />
        </div>

        <hr />
        {isLoading && <misc.components.LoadingAlert />}
        {isError && <misc.components.Alert message={errorMessage} />}

        <div className="list-group">{this.renderClients()}</div>
      </div>
    );
  }
}

ClientList.propTypes = {
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string
    })
  ).isRequired,
  errorMessage: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
  isError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  searchTerm: PropTypes.string.isRequired
};

ClientList.defaultProps = {
  errorMessage: 'Sorry, an error occurred.'
};

export default misc.lib.toJS(ClientList);



// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientList.js